import { Injectable, Injector } from '@angular/core';
import { HttpService } from 'projects/core/src/public-api';
import { ProjectsStore } from '../../modules/project-misc/data/project/projects.store';
import { AppStateStore } from 'projects/desktop/src/app/data/app-state.store';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';
import { Observable } from 'rxjs';
import { User } from 'projects/core/src/lib/login/data/user';
import { TicketsPage } from './tickets-page';

@Injectable({
	providedIn: 'root',
})
export class PageTestsService extends HttpService {
	constructor(
		protected injector: Injector,
		protected projectsStore: ProjectsStore,
		protected appStateStore: AppStateStore,
		protected appStateQuery: AppStateQuery
	) {
		super(injector);
	}

	getCBUsers(): Observable<string[]> {
		return this.doHttpGet<string[]>(`/cb/users`)
	}


	getCBTests(user: string, dateFrom: string, dateTo: string): Observable<TicketsPage> {
		return this.getData(`/cb/testing-status?user=${user}&dateFrom=${dateFrom}&dateTo=${dateTo}`, TicketsPage);
	}


}
